// Which of the two overlaid inputs in RangeSlider must receive the pointer.
//
// DOM order alone puts `hi` on top, which traps the pair when they collapse at
// the top of the range: `hi` cannot move (its own onChange clamps it back up to
// `lo`) and `lo` is buried underneath, so the handles freeze at the right edge
// with no way back. The rule is directional — at the *bottom* of the range `hi`
// must stay on top for exactly the same reason (there it is the one with room
// to move) — so do not "simplify" this to `lo === hi`.
export function topRangeHandle({ lo, hi, max }) {
  return (lo >= max && hi >= max) ? 'lo' : 'hi';
}
